import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import LegalLinesBody from '../../components/LegalPage/LegalLinesBody'
import LegalPageLayout from '../../components/LegalPage/LegalPageLayout'
import { parseLegalTextLines } from '../../utils/parseLegalText'
import { applyLandingSeo } from '../Landing/landingUtils'
import privacyRaw from '../../../public/terms/SpectrAI Privacy Policy.txt?raw'

const PRIVACY_LINES = parseLegalTextLines(privacyRaw)

export default function PrivacyPage() {
  const { t } = useTranslation()

  useEffect(() => {
    applyLandingSeo({
      page: 'landing',
      title: t('privacy.seoTitle'),
      description: t('privacy.seoDescription'),
      path: '/privacy',
    })
  }, [t])

  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, '')
    if (!hash) return
    const scrollToAnchor = () => document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    const frame = window.requestAnimationFrame(scrollToAnchor)
    return () => window.cancelAnimationFrame(frame)
  }, [])

  return (
    <LegalPageLayout>
      <LegalLinesBody lines={PRIVACY_LINES} />
    </LegalPageLayout>
  )
}
